import { useEffect, useState } from 'react';

import { ACCENT_HEX } from './design-tokens';

const FULL = 100;

export const ReadingProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;
      const scrollable = scrollHeight - clientHeight;
      setProgress(
        scrollable <= 0 ? FULL : Math.min(FULL, (scrollTop / scrollable) * FULL)
      );
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div
      aria-hidden
      className="pointer-events-none fixed inset-x-0 top-0 z-[60] h-[3px]"
    >
      <div
        className="h-full"
        style={{ width: `${progress}%`, background: ACCENT_HEX }}
      />
    </div>
  );
};
